import { ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import { GridEditorAdapter, GridEditorOptions, RequestParamsOrder, RowData, ExportType, helpers } from "@reporting/rp-app-host";
import rp from "@reporting/rp-app-host";
import { Query } from "@reporting/rp-types/ext";

const DEFAULT_FIELDS = ['id_thread', 'description', 'type', 'enabled'];
const DEFAULT_ORDER: RequestParamsOrder = [['description', 'asc']];

export class QueryGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	constructor(private idProject: number) { super() }

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;

		this._columns = [{
			t: 'a',
			e: false,
			w: 5 + 20 * 2,
			content: [{
				action: 'delete',
				icon: 'trash',
				color: ColorTypes.Red,
				title: msg('Delete')
			}, {
				action: 'duplicate',
				icon: 'copy',
				color: ColorTypes.Yellow,
				title: msg('Duplicate')
			}],
			filter: false
		}, {
			data: 'id_thread',
			header: '#',
			t: 'n',
			z: '0',
			e: false,
			w: 80
		}, {
			data: 'description',
			header: msg('Name'),
			t: 't',
			e: true,
			w: 200
		}, {
			data: 'type',
			header: msg('Type'),
			t: 's',
			content: [{k: 'definition', v: msg('definition')}, {k: 'save', v: msg('save')}],
			e: true,
			w: 210
		}, {
			data: 'sync',
			header: msg('Sync'),
			t: 'b',
			e: true,
			w: 80
		}];
		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]> {
		return (await rp.ms('extensions').get<Query[]>(`queries`, this.createRequestParams(filters, {
			fields: DEFAULT_FIELDS,
			where: {id_custom_page: this.idProject},
			order: DEFAULT_ORDER,
			count: this.pageSize
		}))).map(data => ({ data }));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			filters: true,
			pageSize: this.pageSize,
			refreshAfterSave: true,
			exportTypes : ['csv', 'xlsx'],
		});
	}

	async save(rowData: RowData[]) {
		const data = rowData.map(row => Object.assign({_state: row.state, _index: row.index}, row.data));
		await rp.ms('extensions').post(`queries`, data);
	}

	async export(type: ExportType) {
		if (type == 'xlsx') return await super.export(type);
		await rp.ms('extensions').download('exportThreads', {
			fields: DEFAULT_FIELDS,
			order: DEFAULT_ORDER,
			fileName: helpers.createExportFilename(type),
			csvParams: {header: true, delimiter: ',', encoding: 'utf-8'},
		});
	}

}
